module.exports = __webpack_public_path__ + "static/media/sound.8c11d48b.mp3";